import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { VisationAction } from '../models/visation-action.model';

@Injectable({
  providedIn: 'root',
})
export class VisationActionService {
  private apiUrl = environment.apiUrl + environment.visationAction;

  constructor(private http: HttpClient) {}

  createVisationAction(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}`, data, {
      headers: {
        enctype: 'multipart/form-data',
      },
    });
  }

  getVisationActionsByVisationId(visationId: number): Observable<VisationAction[]> {
    return this.http.get<VisationAction[]>(`${this.apiUrl}/visation/${visationId}`);
  }
}
